module.exports = __webpack_public_path__ + "static/media/mobile-no-highlight.bedf5ade.svg";